import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  misclassifiedCallsApi,
  type FeedbackTargetType,
  type MisclassifiedCall,
  type MisclassifiedCallInput,
  type UpdateMisclassifiedCallInput,
} from '@/lib/api/misclassified-calls.api';

const QK = ['misclassified-calls'];

export function useMisclassifiedCallList(opts?: {
  tags?: string[];
  targetType?: FeedbackTargetType;
}) {
  return useQuery<MisclassifiedCall[]>({
    queryKey: [...QK, opts ?? {}],
    queryFn: () => misclassifiedCallsApi.list(opts),
  });
}

export function useMisclassifiedCallTags() {
  return useQuery<string[]>({ queryKey: [...QK, 'tags'], queryFn: misclassifiedCallsApi.listTags });
}

export function useMisclassifiedCallDetail(id: string | undefined) {
  return useQuery<MisclassifiedCall>({
    queryKey: [...QK, id],
    queryFn: () => misclassifiedCallsApi.getById(id!),
    enabled: !!id,
  });
}

export function useCreateMisclassifiedCall() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: MisclassifiedCallInput) => misclassifiedCallsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useUpdateMisclassifiedCall() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateMisclassifiedCallInput }) =>
      misclassifiedCallsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeleteMisclassifiedCall() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => misclassifiedCallsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
